import { DocumentActions } from "@/components/admin/document-center/DocumentActions";

interface Document {
  id: string;
  name: string;
  size: number;
  type: string;
  path: string;
  created_at: string;
}

interface DocumentListProps {
  documents: Document[];
  onPreview: (path: string) => void;
  onDownload: (path: string, fileName: string) => void;
  onDelete: (id: string, path: string) => void;
}

export const DocumentList = ({ 
  documents, 
  onPreview, 
  onDownload, 
  onDelete 
}: DocumentListProps) => {
  if (documents.length === 0) {
    return (
      <div className="text-center py-8 text-gray-400">
        No documents uploaded yet.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className="flex justify-between items-center p-4 bg-gray-900/50 rounded-lg"
        >
          <div className="flex-1">
            <h3 className="text-white font-medium">{doc.name}</h3>
            <p className="text-sm text-gray-400">
              {new Date(doc.created_at).toLocaleDateString()} • {(doc.size / 1024 / 1024).toFixed(2)} MB
            </p>
          </div>
          <DocumentActions
            onPreview={() => onPreview(doc.path)}
            onDownload={() => onDownload(doc.path, doc.name)}
            onDelete={() => onDelete(doc.id, doc.path)}
          />
        </div>
      ))}
    </div>
  );
};